export function isColorDark(color: string) {
	const red = Number.parseInt(color.slice(1, 3), 16)
	const green = Number.parseInt(color.slice(3, 5), 16)
	const blue = Number.parseInt(color.slice(5, 7), 16)

	return (red * 299 + green * 587 + blue * 114) / 1000 < 150
}
